<template>
	<div>
		<div>
		<van-cell @click="treeitemtap(treelist)" class="mycell">
			  <template #title>
				<div class="custom-title" v-if="treelist.children" :style="{'padding-left':(treelistindex*5)+'px'}">{{treelist.item}}</div>
			    <div class="custom-title" v-if="!treelist.children" >{{treelist.item.alias}}</div>
			  </template>
			  <template #label v-if="!treelist.children">
			    <span class="custom-title" >{{getresourcelabel(treelist.item)}}</span>
			    <van-tag type="danger" v-if="treelist.item.trySee==1&&treelist.item.currentLearning!=1" >免费试听</van-tag>
				<van-tag type="danger" v-if="treelist.item.currentLearning==1" >上次学到</van-tag>
			  </template>
			  <template #right-icon>  
			    <van-icon v-if="treelist.children&&collapse" name="arrow-down" class="van-cell__right-icon"/>
				<van-icon v-if="treelist.children&&!collapse" name="arrow-up" class="van-cell__right-icon"/>
				<van-icon v-if="!treelist.children&&treelist.item.resourceType==1&&treelist.item.lessonStatus==1" name="/img/260.png" size="25" style="margin-top: 10px;padding-right: 10px;"/>
			  </template>
			  <template #icon v-if="!treelist.children">
				<van-icon name="audio" size="25"  v-if="treelist.item.resourceType==1" :style="{'margin-top':'10px','padding-right':'10px','padding-left':(treelistindex*5)+'px'}"/>
			    <van-icon name="video-o" size="25"  v-if="treelist.item.resourceType==2" :style="{'margin-top':'10px','padding-right':'10px','padding-left':(treelistindex*5)+'px'}"/>
				<van-icon name="label-o" size="25"  v-if="treelist.item.resourceType==9" :style="{'margin-top':'10px','padding-right':'10px','padding-left':(treelistindex*5)+'px'}"/>
			  </template>
		</van-cell>
		<div v-if="treelist.children&&!collapse">
			<ctree  v-for="(item,index) in treelist.children" :key="index" :treelist="item" :treelistindex="treelistindex+1" @treeTap="treenodetap"></ctree>
		</div>
		</div>
	</div>
</template>

<script>
	import ctree from '@/components/ctree.vue'
	export default {
	  name: "ctree",
	  props: {
	    treelist: Object,
		treelistindex:{
			type:Number,
			default:0
		}
	  },
	  data(){
		  return{
			  collapse:false //每个tree组件对应自己的collapse属性；（true:折叠/false:展开;）
		  }
		  
	  },
	  methods:{
		  treeitemtap(item){
			  console.log(item);
			  //console.log("treelistindex:",this.treelistindex);
			  var treeitem=item;
			  if(treeitem.children!==undefined){
				  this.collapse=!this.collapse;
			  }
			  else{
				  this.$emit("treeTap",item)
			  }
		  },
		  treenodetap(item){
			  //console.log("node:",item);
			  this.$emit("treeTap",item);
		  },
		  getresourcelabel(treeitem){
			  var labelstr="";
			  var lessonextstr=treeitem.lessonExt;
			  var lessonextobj=eval('('+lessonextstr+')');
			  //console.log(lessonextobj);
			  if(treeitem.resourceType==1){
				  var lessonStartTime=this.timestampToTime(treeitem.lessonStartTime);
				  
				  if(treeitem.lessonStatus==0){
					  labelstr="直播未开始 | "+lessonStartTime+" ";
				  }
				  if(treeitem.lessonStatus==1){
					  labelstr="直播中 | "+lessonStartTime+" ";
				  }
				  if(treeitem.lessonStatus==2){
					  labelstr="直播结束待处理 | "+lessonStartTime+" ";
				  }
				  if(treeitem.lessonStatus==3){
					  labelstr="直播回放 | "+lessonStartTime+" ";
				  }
				  if(treeitem.studyRate!=undefined){
					  labelstr+=" | 上次学到"+treeitem.studyRate+"%"
				  }
				  
			  }
			  if(treeitem.resourceType==2){
				  if(lessonextobj!=undefined)
					labelstr="录播 | "+lessonextobj.duration+" ";
				  else{
					  labelstr="录播 ";
				  }
				  if(treeitem.studyRate!=undefined){
					  labelstr+=" | 上次学到"+treeitem.studyRate+"%"
				  }
			  }
			  if(treeitem.resourceType==9){
				  labelstr="面授";
			  }
			  
			  return labelstr;
		  },
		  timestampToTime(timestamp) {
		  	      const t = new Date(timestamp)
		  	        // 日期格式
		  	        const format = 'Y-m-d h:i:s'
		  	        let year = t.getFullYear()
		  	        // 由于 getMonth 返回值会比正常月份小 1
		  	        let month = t.getMonth() + 1
		  	        let day = t.getDate()
		  	        let hours = t.getHours()
		  	        let minutes = t.getMinutes()
		  	        let seconds = t.getSeconds()
		  	        month = month > 9 ? month : `0${month}`
		  	        day = day > 9 ? day : `0${day}`
		  	        hours = hours > 9 ? hours : `0${hours}`
		  	        minutes = minutes > 9 ? minutes : `0${minutes}`
		  	        seconds = seconds > 9 ? seconds : `0${seconds}`
		  	        const hash = {
		  	          'Y': year,
		  	          'm': month,
		  	          'd': day,
		  	          'h': hours,
		  	          'i': minutes,
		  	          's': seconds
		  	        }
		  	        return format.replace(/\w/g, o => {
		  	          return hash[o]
		  	        })
		  	}
	  },
	components: {
		ctree
	}
	  
	};
</script>

<style scoped>
	 .van-cell--borderless::after, .van-cell:last-child::after{
		display: block !important;
	}
	  .custom-title {
		  font-size: 12px;
		  text-overflow:ellipsis;
		  white-space: nowrap;
		  overflow:hidden;
		  word-break:break-all;
		  width:18rem;
		  margin-right: 1.25rem;
	  }
	.mycell::after{
		position: absolute;
		box-sizing: border-box;
		content: ' ';
		pointer-events: none;
		right: 16px;
		bottom: 0;
		left: 16px;
		border-bottom: 1px solid #ebedf0;
		-webkit-transform: scaleY(.5);
		transform: scaleY(.5);
	}
</style>
